import MApp from "../../modules/MApp";
import MForm from "../../modules/MForm";
import MModal from "../../modules/MModal";
import MRequest from "../../modules/MRequest";
import MMeasurements from "./MMeasurements";

export default class MMeasurementsForm
{
	constructor(el)
	{
		this.el = el;
	}

	static selector = () => `.profile-measurements-form`;

	static addEventListeners()
	{
		document.addEventListener('submit', event => {
			if (event.target.matches(this.selector())) {
				event.preventDefault();

				const measurementsForm = new this(event.target.closest(this.selector()));
				measurementsForm.handleSubmit();
			}
		});

		document.addEventListener('click', event => {
			if (event.target.matches(`${this.selector()} [type="submit"]`)) {
				event.preventDefault();

				const measurementsForm = new this(event.target.closest(this.selector()));
				measurementsForm.handleSubmit();
			}
		});
	}

	handleSubmit()
	{
		const form = new MForm(this.el);
		const data = form.getData();

		form.resetErrors();
		form.disable();

		MRequest.call(form.getMethod(), form.getUrl(), data).then(response => {
			try {
				const measurements = new MMeasurements(document.querySelector(MMeasurements.selector()));
				measurements.setHtml(response.data.templates.table);
			} catch (error) {
				// Nevermind.
			}

			MModal.closeAll();
		}).catch(error => {
			form.setErrorResponse(error);
		}).finally(() => {
			form.enable();
			MApp.refresh();
		})
	}
}
